<!--===============================
=            DASHBORD2            =
================================-->
<template>

  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Dashboard2</div>
      </base-header>
    </v-row>
    <v-row>


      <v-col cols="12" md="3" sm="6">
        <v-card color="primary lighten-1" class="rounded-lg ma-1" height="150">

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="subtitle-1 font-weight-black white--text">
                Income
              </v-list-item-title>
              <v-list-item-subtitle class="text-caption font-weight-light white--text">Type Of Finances
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            <v-row class="align-center">
              <v-col class="text-h4 font-weight-black white--text " cols="5">
                35%
              </v-col>
              <v-col cols="7">
                <v-sparkline :value="value" :fill="fill" color="rgba(255, 255, 255, .7)" height="150" padding="24"
                             elevation="3" stroke-linecap="round" smooth>
                  <template v-slot:label="item">
                    ${{ item.value }}
                  </template>
                </v-sparkline>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <v-card color="primary lighten-2" class="rounded-lg ma-1" height="150">

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="subtitle-1 font-weight-black white--text">
                Projects
              </v-list-item-title>
              <v-list-item-subtitle class="text-caption font-weight-light white--text">Type Of Jobs
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            <v-row class="align-center">
              <v-col class="text-h4 font-weight-black white--text " cols="5">
                16%
              </v-col>
              <v-col cols="7">
                <v-sparkline :value="value" :fill="fill" color="rgba(255, 255, 255, .7)" height="150" padding="24"
                             elevation="3" stroke-linecap="round" smooth>
                  <template v-slot:label="item">
                    ${{ item.value }}
                  </template>
                </v-sparkline>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <v-card color="primary lighten-3" class="rounded-lg ma-1" height="150">

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="subtitle-1 font-weight-black white--text">
                Rocket
              </v-list-item-title>
              <v-list-item-subtitle class="text-caption font-weight-light white--text">Type Of Finances
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            <v-row class="align-center">
              <v-col class="text-h4 font-weight-black white--text " cols="5">
                42%
              </v-col>
              <v-col cols="7">
                <v-sparkline :value="value" :fill="fill" color="rgba(255, 255, 255, .7)" height="150" padding="24"
                             elevation="3" stroke-linecap="round" smooth>
                  <template v-slot:label="item">
                    ${{ item.value }}
                  </template>
                </v-sparkline>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="3" sn="6">
        <v-card color="primary lighten-4" class="rounded-lg ma-1" height="150">

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="subtitle-1 font-weight-black white--text">
                Location
              </v-list-item-title>
              <v-list-item-subtitle class="text-caption font-weight-light white--text">Type Of Finances
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            <v-row class="align-center">
              <v-col class="text-h4 font-weight-black white--text " cols="5">
                96%
              </v-col>
              <v-col cols="7">
                <v-sparkline :value="value" :fill="fill" color="rgba(255, 255, 255, .7)" height="150" padding="24"
                             elevation="3" stroke-linecap="round" smooth>
                  <template v-slot:label="item">
                    ${{ item.value }}
                  </template>
                </v-sparkline>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="8" sm="12">
        <base-card>
          <div slot="card-header">

            Total Transactions
          </div>
          <div slot="card-subheader">Commodo sit veniam enim aute mollit ut qui.</div>
          <div slot="card-body">
            <echarts-area></echarts-area>
          </div>
        </base-card>

      </v-col>
      <v-col cols="12" md="4" sm="12">
        <base-card>
          <div slot="card-header">
            Recents Orders
          </div>
          <div slot="card-subheader">Commodo sit veniam enim aute mollit ut qui.</div>
          <div slot="card-body">
            <apex-chart-pie></apex-chart-pie>
            <v-divider></v-divider>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="white--text text-h5">
                  San Francisco
                </v-list-item-title>
                <v-list-item-subtitle class="white--text">Mon, 12:30 PM, Mostly sunny</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

          </div>
        </base-card>


      </v-col>
      <v-col cols="12" md="4" sm="12">
        <base-card>
          <div slot="card-header">

            Lists Personal Tasks
          </div>
          <div slot="card-subheader">Commodo sit veniam enim aute mollit ut qui.</div>
          <div slot="card-body">

            <v-list-item class="ml-n4 mt-n2" dense v-for="folder in folders" dark :key="folder.title">
              <v-list-item-avatar class="rounded-lg ">
                <v-icon class="primary" dark>
                  mdi-folder
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="folder.title"></v-list-item-title>

                <v-list-item-subtitle v-text="folder.subtitle"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn icon>
                  <v-icon color="grey lighten-1">mdi-information</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

          </div>
        </base-card>
      </v-col>

      <v-col cols="12" md="4" sm="12">
        <base-card>
          <div slot="card-header">

            Weather forecast
          </div>
          <div slot="card-subheader">Commodo sit veniam enim aute mollit ut qui.</div>
          <div slot="card-body">
            <v-list-item dark two-line>
              <v-list-item-content>
                <v-list-item-title class="text-h6">
                  San Francisco
                </v-list-item-title>
                <v-list-item-subtitle>Mon, 12:30 PM, Mostly sunny</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-card-text>
              <v-row class="align-center">
                <v-col class="text-h3" cols="7">
                  23&deg;C
                </v-col>
                <v-col cols="5">
                  <v-img src="../../assets/images/sol.png" alt="Sunny image" width="102"></v-img>
                </v-col>
              </v-row>
            </v-card-text>


          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <base-card>
          <div slot="card-header">

            Social Engagement
          </div>
          <div slot="card-subheader">Commodo sit veniam enim aute mollit ut qui.</div>
          <div slot="card-body">
            <v-list-item dark two-line>
              <v-list-item-content>
                <v-list-item-title class="text-h3">
                  59%
                </v-list-item-title>
                <v-list-item-subtitle>Social Engagement in Instagram</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-card-text>
              <v-row class="align-start">
                <v-col class="text-h5" cols="8">
                  +254 </br>
                  Follows

                </v-col>
                <v-col cols="4">
                  <v-img src="../../assets/images/icons/instagram.png" alt="Sunny image" width="102"></v-img>
                </v-col>
              </v-row>
            </v-card-text>


          </div>
        </base-card>
      </v-col>
    </v-row>


  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  import EchartsArea from '../../components/Charts/EchartsArea'
  import ApexChartPie from '../../components/Charts/ApexChartPie'
  export default {
    components: {
      BaseCard,
      BaseHeader,
      EchartsArea,
      ApexChartPie
    },
    data: () => ({
      loading: false,
      selection: 1,
      fill: false,
      labels: [
        '12am',
        '3am',
        '6am',
        '9am',
        '12pm',
        '3pm',
        '6pm',
        '9pm',
      ],
      value: [
        200,
        675,
        410,
        390,
        310,
        460,
        250,
        240,
      ],
      folders: [{
          subtitle: 'Jan 9, 2014',
          title: 'Photos',
        },
        {
          subtitle: 'Jan 17, 2014',
          title: 'Recipes',
        },
        {
          subtitle: 'Jan 28, 2014',
          title: 'Work',
        }, {
          subtitle: 'Jan 28, 2014',
          title: 'Studs',
        },
      ],
      cards: [{
          title: 'Weather',
          icon: 'thermostat',
          src: 'weather',
          flex: 2
        },
        {
          title: 'Mathio',
          icon: 'calculate',
          src: 'calc',
          flex: 2
        },
        {
          title: 'Bank',
          icon: 'savings',
          src: 'money',
          flex: 2
        }, {
          title: 'Travel',
          icon: 'flight',
          src: 'travel',
          flex: 2
        },
        {
          title: 'Games',
          icon: 'sports_esports',
          src: 'game',
          flex: 2
        }, {
          title: 'Jobs',
          icon: 'work_outline',
          src: 'work',
          flex: 2
        },
      ],
    }),

    methods: {
      reserve() {
        this.loading = true

        setTimeout(() => (this.loading = false), 2000)
      },
    },

  }
</script>

<style>
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
</style>


<!--====  End of DASHBORD2  ====-->